import { render, staticRenderFns } from "./ssoUnknownWidget.vue?vue&type=template&id=537492a3&"
import script from "./ssoUnknownWidget.vue?vue&type=script&lang=js&"
export * from "./ssoUnknownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\TeamCity\\Edison.Sso\\Dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537492a3')) {
      api.createRecord('537492a3', component.options)
    } else {
      api.reload('537492a3', component.options)
    }
    module.hot.accept("./ssoUnknownWidget.vue?vue&type=template&id=537492a3&", function () {
      api.rerender('537492a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "v-components/widgets/ssoUnknownWidget.vue"
export default component.exports